import { render, staticRenderFns } from "./bv-swiper-scroll.vue?vue&type=template&id=e3a1d29a&scoped=true"
import script from "./bv-swiper-scroll.vue?vue&type=script&lang=js"
export * from "./bv-swiper-scroll.vue?vue&type=script&lang=js"
import style0 from "./bv-swiper-scroll.vue?vue&type=style&index=0&id=e3a1d29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a1d29a",
  null
  
)

export default component.exports